import React from "react"
import SearchIcon from "@material-ui/icons/Search"

import { makeStyles } from "@material-ui/core/styles"

import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DeviceCarousel from "../DeviceCarousel/DeviceCarousel"

import CloseIcon from "@material-ui/icons/Close"

import useMediaQuery from "@material-ui/core/useMediaQuery"
import { navigate } from "gatsby"

const DeviceCard = (props) => {
  const [open, setOpen] = React.useState(false)
  const { card, index } = props

  const fullScreen = useMediaQuery("(max-width: 1023px)")

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = (index) => {
    setOpen(false)
    navigate(`/services/hardware_leasing#${index}`)
  }

  const useStyles = makeStyles({
    dialog: {
      backgroundColor: "transparent",
      margin: 0,
      padding: "10px 0px !important",
      maxWidth: "lg",
      "@media screen and (max-width: 767px)": {
        padding: "0",
        width: "100%",
        margin: "0",
      },
    },
    dialogWrapper: {
      width: "1000px",
      height: "700px",
      margin: "auto auto",
      "@media screen and (max-width: 1023px)": {
        width: "700px",
      },
      "@media screen and (max-width: 767px)": {
        width: "100%",
        height: "100%",
      },
    },
    title: {
      textAlign: "center",
      fontFamily: "Bariol Regular",
      "@media screen and (max-width: 767px)": {
        fontSize: "12pt",
      },
    },
    close: {
      display: "none",
      "@media screen and (max-width: 1023px)": {
        display: "flex",
        position: "absolute",
        top: "20px",
        right: "20px",
        cursor: "pointer",
      },
    },
  })

  const classes = useStyles()

  return (
    <div className="one-device-wrapper" id={index}>
      <div className="device-body">
        <h3>{card.value.text_device_name}</h3>
        <div
          className="device-description"
          dangerouslySetInnerHTML={{
            __html: card.value.wysiwyg_device_description,
          }}
        ></div>
        <div
          className="device-list_description"
          dangerouslySetInnerHTML={{
            __html: card.value.wysiwyg_device_list_description,
          }}
        ></div>
        <a
          href={card.value.set_device_manufacturer_link.link_URL}
          target={"_blank"}
          rel="noopener noreferrer"
        >
          {card.value.set_device_manufacturer_link.link_text}
        </a>
      </div>
      <div
        className="image-wrapper"
        role="presentation"
        onClick={() => {
          handleClickOpen()
        }}
      >
        <img
          src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${card.value.asset_device_picture.path}`}
          alt={`hardware-picture_${index}`}
        />
        <div className="arrowup-icon">
          <SearchIcon />
        </div>
      </div>
      <div className="device-prices">
        <div className="device-price">
          <div>{card.value.set_device_prices.text_list_price}</div>
          <div>listaár</div>
        </div>
        <div className="device-price">
          <div>{card.value.set_device_prices.text_prodhost_price}</div>
          <div>prodHost ügyfeleknek</div>
        </div>
      </div>
      <div className="device-price-per-month">
        <div className="device-price-box">
          <div>12 hónapra</div>
          <div>{card.value.set_device_prices.text_12months_price}</div>
        </div>
        <div className="device-price-box">
          <div>24 hónapra</div>
          <div>{card.value.set_device_prices.text_24months_price}</div>
        </div>
        <div className="device-price-box">
          <div>36 hónapra</div>
          <div>{card.value.set_device_prices.text_36months_price}</div>
        </div>
      </div>

      <Dialog
        className={`device-dialog ${classes.dialogWrapper}`}
        fullScreen={fullScreen}
        open={open}
        onClose={() => handleClose(index)}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent className={classes.dialog}>
          <h1 className={classes.title}>{card.value.text_device_name}</h1>
          <div className={classes.close} onClick={() => handleClose(index)}>
            <CloseIcon />
          </div>
          <DeviceCarousel carousel={card.value.arr_device_pictures} />
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default DeviceCard
